import api from 'helpers/api';
import { reverse } from 'named-urls';
import { urls } from 'routes/api';

export default class Settings {
    constructor(id_setting = 0) {
        this.id_setting = id_setting;
    }

    async list(params) {
        let url = reverse(urls.admin.settings.get);
        const { data } = await api.get(url, { params: params });
        return data;
    }

    async show() {
        let url = reverse(urls.admin.settings.edit, { id_setting: this.id_setting });
        const { data } = await api.get(url);
        return data;
    }

    async update(values) {
        let url = reverse(urls.admin.settings.edit, { id_setting: this.id_setting });
        const { data } = await api.put(url, values);
        return data;
    }

    async save(values) {
        return this.update(values);
    }
}
